import { Component, inject, OnInit, signal } from '@angular/core';
import { SidebarComponent } from '@app/core/sidebar/sidebar.component';
import { MapComponent } from '@app/core/map/map.component';
import { ActivatedRoute } from '@angular/router';
import { AltitudeAndSpeedGraphComponent } from "../../../../shared/ngx-charts/altitude-and-speed-graph/altitude-and-speed-graph.component";
import { Route } from '@app/shared/models/ride-history/route.model';
import { HttpService } from '@app/service/http/http.service';
import { environment } from '@environments/environment';
import { CommonModule } from '@angular/common';
import { backendRestApis } from '@environments/backend-rest-apis';

@Component({
  selector: 'app-route-details',
  imports: [
    SidebarComponent,
    MapComponent,
    AltitudeAndSpeedGraphComponent,
    CommonModule
  ],
  templateUrl: './route-details.component.html',
  styleUrl: './route-details.component.css',
})
/**
 * Komponenta za prikaz detalja pojedine rute.
 * Prikazuje informacije i grafove za odabranu rutu.
 */
export class RouteDetailsComponent implements OnInit {

  private httpService = inject(HttpService);

  routeId = signal<number>(0);
  private route = inject(ActivatedRoute);
  routes = signal<Route[] | undefined>(undefined);

  /**
   * Inicijalizira komponentu i dohvaća podatke o odabranoj ruti.
   */
  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.routeId.set(+params['routeId']);

      const url = `${environment.apiUrl}${backendRestApis.route.getRouteWithId(this.routeId())}`;
      const subscription = this.httpService.get<Route>(url).subscribe({
        next: (routeArray) => {
          this.routes.set([routeArray]);
        },
      });

      this.httpService.unsubscribeWithDestroyRef(subscription);
    });
  }
}
